<div class="wrap">
  <div #mapContainer id="mapContainer" class="map-container" style="height:70vh"></div>
  <div #markersContainer></div>
  <div class="info">Lat: {{map?.getCenter()?.lat?.toFixed(6)}}, Long: {{map?.getCenter()?.lng?.toFixed(6)}} (WGS 84)</div>

  <!-- Detail Drawer -->
  <div class="detail-drawer" [class.open]="drawerOpen">
    <div class="drawer-header">
      <span class="drawer-title">{{drawerWell?.wellName}}</span>
      <button class="drawer-close" (click)="closeDrawer()">&times;</button>
    </div>
    <div class="drawer-status" [style.color]="drawerWell?.startIn | statusColor : drawerWell?.duration">
      {{getDrawerStatusText()}}
    </div>
    <div class="drawer-progress">
      <div class="progress-base"></div>
      <div class="progress-value" [ngStyle]="{
        'background-color': drawerWell?.startIn | statusColor : drawerWell?.duration,
        width: getDrawerProgress() + '%'
      }"></div>
    </div>
    <div class="drawer-progress-text">{{getDrawerProgressText()}}</div>

    <!-- Tabs -->
    <div class="drawer-tabs">
      <button class="drawer-tab-btn" [class.active]="drawerTab === 'operations'" (click)="drawerTab = 'operations'">Operations</button>
      <button class="drawer-tab-btn" *ngIf="drawerWeather" [class.active]="drawerTab === 'weather'" (click)="drawerTab = 'weather'">Weather</button>
    </div>

    <!-- Operations Tab -->
    <div class="drawer-content" *ngIf="drawerTab === 'operations'">
      <div class="drawer-field">
        <div class="drawer-label">Region</div>
        <div class="drawer-value">{{drawerWell?.regionCode || '-'}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">State</div>
        <div class="drawer-value">{{drawerWell?.state}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">County</div>
        <div class="drawer-value">{{drawerWell?.county}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">Operator</div>
        <div class="drawer-value">{{drawerWell?.companyName}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">API</div>
        <div class="drawer-value">{{drawerWell?.api?.substring(0, 14)}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">Scheduled Frac Start</div>
        <div class="drawer-value">{{drawerWell?.fracStartDate | dateFormatter}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">Scheduled Frac End</div>
        <div class="drawer-value">{{drawerWell?.fracEndDate | dateFormatter}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">TVD</div>
        <div class="drawer-value">{{drawerWell?.tvd}}</div>
      </div>
      <div class="drawer-field">
        <div class="drawer-label">Target Formation</div>
        <div class="drawer-value">{{drawerWell?.targetFormation}}</div>
      </div>
      <div class="drawer-field" *ngIf="drawerReview">
        <div class="drawer-label">Risk Level</div>
        <div class="drawer-value">
          <span *ngIf="drawerReview.riskLevel && drawerReview.riskLevel !== 'None'"
                class="risk-badge" [ngClass]="getDrawerRiskClass(drawerReview.riskLevel)">
            {{drawerReview.riskLevel}}
          </span>
          <span *ngIf="!drawerReview.riskLevel || drawerReview.riskLevel === 'None'" class="risk-none">None</span>
        </div>
      </div>
      <div class="drawer-field" *ngIf="drawerReview">
        <div class="drawer-label">Performed By</div>
        <div class="drawer-value">{{drawerReview.reviewerName}}</div>
      </div>
      <div class="drawer-field" *ngIf="drawerReview">
        <div class="drawer-label">Performed Date</div>
        <div class="drawer-value">{{drawerReview.reviewDate | dateFormatter}}</div>
      </div>
    </div>

    <!-- Weather Tab -->
    <div class="drawer-content" *ngIf="drawerTab === 'weather' && drawerWeather">
      <div class="weather-current">
        <div class="weather-header">
          <span class="section-title">Current Conditions</span>
          <img [src]="getWeatherIcon(drawerWeather.current.weather.icon)"
               alt="weather"
               class="weather-icon-lg">
        </div>
        <div class="weather-temp">{{drawerWeather.current.temp}}°F</div>
        <div class="weather-desc">{{drawerWeather.current.weather.description}}</div>
        <div class="weather-details">
          <span>Wind: {{drawerWeather.current.windSpeed}} mph</span>
          <span>Humidity: {{drawerWeather.current.humidity}}%</span>
        </div>
      </div>

      <div class="weather-risk" [ngClass]="getWeatherRiskClass(drawerWeather.operationalRisk)">
        <strong>Operational Risk:</strong> {{getWeatherRiskLabel(drawerWeather.operationalRisk)}}
      </div>

      <div *ngIf="drawerWeather.alerts && drawerWeather.alerts.length > 0" class="weather-alerts">
        <div class="alert-header">
          <strong>Weather Alerts ({{drawerWeather.alerts.length}})</strong>
        </div>
        <div *ngFor="let alert of drawerWeather.alerts" class="alert-item">
          <span class="alert-event">{{alert.event}}</span>
          <span class="alert-severity"
                [style.color]="alert.severity === 'extreme' || alert.severity === 'severe' ? '#dc3545' : '#ffc107'">
            ({{alert.severity}})
          </span>
        </div>
      </div>

      <div class="forecast-preview" *ngIf="drawerWeather.forecast && drawerWeather.forecast.length > 0">
        <div class="section-title">5-Day Forecast</div>
        <div class="forecast-grid">
          <div *ngFor="let day of drawerWeather.forecast.slice(0, 5)" class="forecast-day">
            <div class="day-name">{{day.date | date:'EEE'}}</div>
            <img [src]="getWeatherIcon(day.weather.icon)" alt="forecast" class="weather-icon-sm">
            <div class="day-temps">
              <span class="temp-high">{{day.tempHigh}}°</span>
              <span class="temp-divider">/</span>
              <span class="temp-low">{{day.tempLow}}°</span>
            </div>
            <div *ngIf="day.precipProbability > 30" class="precip-chance">
              {{day.precipProbability}}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right-side map controls — slide left when detail drawer is open -->
  <div class="map-controls-right" [class.drawer-open]="drawerOpen">
    <div *ngIf="showWeatherOverlay" class="weather-controls">
      <label class="weather-label">Layer:</label>
      <select [(ngModel)]="selectedWeatherLayer"
              (change)="changeWeatherLayer()"
              class="weather-select">
        <option value="precipitation">Precipitation</option>
        <option value="clouds">Clouds</option>
        <option value="temperature">Temperature</option>
        <option value="wind">Wind Speed</option>
      </select>

      <label class="weather-label">Opacity:</label>
      <input type="range"
             [(ngModel)]="weatherOpacity"
             (input)="updateWeatherOpacity()"
             min="0"
             max="100"
             class="weather-opacity-slider">
      <span class="opacity-value">{{ weatherOpacity }}%</span>
    </div>

    <div *ngIf="showWeatherOverlay && weatherUnavailable" class="weather-warning">
      {{ weatherUnavailableMessage }}
    </div>

    <div *ngIf="showMeasureTool" class="measure-div">
      <div style="display:flex;width:100%">
        <span class="popup-title">Measure</span>
        <button (click)="enableMeasurement(false)" class="popup-close-btn"><span></span></button>
      </div>
      <mat-select (selectionChange)="onSelectUnit()" class="mat-select" placeholder="Select" [(ngModel)]="selectedMeasureUnits">
        <mat-option class="mat-option" [value]="'Miles'">Miles</mat-option>
        <mat-option class="mat-option" [value]="'Kilometers'">Kilometers</mat-option>
        <mat-option class="mat-option" [value]="'Feet'">Feet</mat-option>
        <mat-option class="mat-option" [value]="'Meters'">Meters</mat-option>
        <mat-option class="mat-option" [value]="'Yards'">Yards</mat-option>
      </mat-select>
      <span *ngFor="let sval of measureTool.valueStrings" style="padding-left:10px;width:100%">{{sval}}</span>
      <button class="reset-button" (click)="startDistanceMeasure()"><span>Reset</span></button>
    </div>
  </div><!-- /.map-controls-right -->

  <div *ngIf="showWeatherBetaPopup" class="weather-beta-toast" role="status" aria-live="polite">
    <div class="weather-beta-title">Weather Overlay (Preview)</div>
    <div class="weather-beta-body">
      Operational aid for scheduling decisions. Data may be temporarily unavailable due to free-tier limits.
      For critical decisions, confirm with primary weather sources.
    </div>
  </div>

  <!-- Region Sidebar -->
  <div class="region-sidebar" [class.collapsed]="!regionSidebarOpen" [class.visible]="data.length > 0">
  <div class="sidebar-header" (click)="toggleRegionSidebar()">
    <span class="sidebar-header-title" *ngIf="regionSidebarOpen">Activity</span>
    <span class="sidebar-chevron">{{ regionSidebarOpen ? '&#8250;' : '&#8249;' }}</span>
  </div>

  <div class="sidebar-content" *ngIf="regionSidebarOpen">
    <!-- Schedule Summary -->
    <div class="sidebar-section">
      <div class="titles">Schedule Summary</div>
      <div class="row-line" *ngIf="summaryData.operating > 0;">
        <span class="line-bar green" [ngStyle]="styleSummaryLine('operating')" style="position: relative; top: 0; left: 0;"></span>
        <div class="txt">Operating</div>
        <span class="num-point">{{summaryData.operating}}</span>
      </div>
      <div class="row-line" *ngIf="summaryData.next7 > 0;">
        <span class="line-bar orange" [ngStyle]="styleSummaryLine('next7')" style="position: relative; top: 0; left: 0;"></span>
        <div class="txt">Next 7</div>
        <span class="num-point">{{summaryData.next7}}</span>
      </div>
      <div class="row-line" *ngIf="summaryData.next8_30 > 0;">
        <span class="line-bar yellow" [ngStyle]="styleSummaryLine('next8_30')" style="position: relative; top: 0; left: 0;"></span>
        <div class="txt">Next 8 - 30</div>
        <span class="num-point">{{summaryData.next8_30}}</span>
      </div>
      <div class="row-line" *ngIf="summaryData.next31_60 > 0;">
        <span class="line-bar pink" [ngStyle]="styleSummaryLine('next31_60')" style="position: relative; top: 0; left: 0;"></span>
        <div class="txt">Next 31 - 60</div>
        <span class="num-point">{{summaryData.next31_60}}</span>
      </div>
      <div class="row-line" *ngIf="summaryData.next61_90 > 0;">
        <span class="line-bar blue" [ngStyle]="styleSummaryLine('next61_90')" style="position: relative; top: 0; left: 0;"></span>
        <div class="txt">Next 61 - 90</div>
        <span class="num-point">{{summaryData.next61_90}}</span>
      </div>
    </div>

    <ng-container *ngIf="regionSummary.length >= 2">
    <div class="sidebar-divider"></div>

    <!-- Region List -->
    <div class="sidebar-section">
      <div class="titles">Regions</div>
      <div class="region-list">
        <div *ngFor="let r of regionSummary"
             class="region-item"
             (click)="zoomToRegion(r.region)">
          <span class="region-dot" [style.background-color]="r.color"></span>
          <span class="region-name">{{r.region}}</span>
          <span class="region-count">{{r.activeCount}}</span>
        </div>
      </div>
    </div>
    </ng-container>
  </div>
</div>
</div>
